import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero/Hero';
import HomeDeals from '../components/HomeDeals/HomeDeals';
import { PromoStrip, ClearanceBanner, TrustBar } from '../components/HomeDeals/HomeExtras';
import Categories from '../components/Categories/Categories';
import FeaturedProducts from '../components/FeaturedProducts/FeaturedProducts';
import { useSite } from '../context/SiteContext';
import './HomeSeo.css';

const Home = () => {
  const { siteName, tagline, fullAddress, email, phone } = useSite();

  return (
    <>
      <Hero />
      <PromoStrip />
      <HomeDeals />
      <ClearanceBanner />
      <FeaturedProducts />
      <Categories />
      <TrustBar />

      <section className="home-seo" aria-labelledby="home-seo-heading">
        <div className="home-seo-inner">
          <h2 id="home-seo-heading">Why shop {siteName}?</h2>
          <p className="home-seo-lead">
            {tagline} Discover women&apos;s fashion, men&apos;s clothing, activewear, shoes, home
            essentials, bags, jewelry, and beauty — with daily deals, free shipping on orders $75+,
            and easy 30-day returns. Your one-stop online store for style that fits real life and a real budget.
          </p>
          <div className="home-seo-grid">
            <div>
              <h3>Shop departments</h3>
              <ul>
                <li><Link to="/category/women">Women&apos;s clothing &amp; dresses</Link></li>
                <li><Link to="/category/men">Men&apos;s clothing &amp; denim</Link></li>
                <li><Link to="/category/shoes">Shoes &amp; sneakers</Link></li>
                <li><Link to="/category/home">Home &amp; living</Link></li>
                <li><Link to="/sale">Sale &amp; clearance deals</Link></li>
              </ul>
            </div>
            <div>
              <h3>Help &amp; policies</h3>
              <ul>
                <li><Link to="/shipping">Shipping information</Link></li>
                <li><Link to="/returns">Returns &amp; exchanges</Link></li>
                <li><Link to="/faqs">FAQs</Link></li>
                <li><Link to="/contact">Contact customer service</Link></li>
                <li><Link to="/privacy">Privacy policy</Link></li>
              </ul>
            </div>
            <div>
              <h3>Visit &amp; connect</h3>
              <p>{fullAddress}</p>
              <p>
                <a href={`mailto:${email}`}>{email}</a>
                <br />
                <a href={`tel:${phone.replace(/[^+\d]/g, '')}`}>{phone}</a>
              </p>
              <p>
                <Link to="/about">About {siteName}</Link>
                {' · '}
                <Link to="/terms">Terms of use</Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
